exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-btn[data-v-35d0fc40] {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  text-align: left;\n}\n.save-icon[data-v-35d0fc40] {\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n", ""]);

// exports
